// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'chevron-solid';

export const Component = () => (
  <path
    fill='currentColor'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='m17.28 8.568-5.472-5.472c-.216-.216-.504-.36-.792-.36H.792l4.68 5.76a.565.565 0 0 1 0 .792l-4.68 5.76h10.224c.288 0 .576-.144.792-.36l5.472-5.472c.216-.072.216-.36 0-.648z'
  />
);

export const viewBox = '0 0 18 18';
